import { useEffect } from "react"
import { useChatSession } from "@chainlit/react-client";

export default function HelpDeskSession(){
    const { session } = useChatSession();
    
    useEffect(()=>{
        if (session){
            session.socket.on("google_session_id", (data) => {
                const sesion_id = data?.value

                const Beacon = window.Beacon || window.parent?.Beacon;
                if (typeof Beacon !== 'undefined') {
                    Beacon('prefill', {
                        subject: `Session ID: ${data.value}`,
                        text: ''
                    })
                } else {
                    console.error('Beacon unavailable')
                }
            });

            return () => {
                session.socket.off("google_session_id");
            };
        }
        // threadId && get_session_id()
    },[session?.socket])

    useEffect(()=>{
        const pathname = window.location.pathname
        const Beacon = window.Beacon || window.parent?.Beacon;
        if (typeof Beacon !== 'undefined' && (pathname == '/login' || pathname == '/register')) {
            Beacon('prefill', {
                subject: '',
                text: ''
            })
        } else {
            console.error('Beacon unavailable')
        }
    },[window.location.pathname])

    return (
        <></>
    )
}
